import { Result } from 'antd';
import { useTranslation } from 'react-i18next';

const RedirectToHome = ({ message }: { message: string }) => {
  const { t } = useTranslation();

  return <Result status="error" title={t('booking.accessDenied')} subTitle={message} />;
};

export default RedirectToHome;
